import { FC } from "react"
import { PlatformPage as PlatformPageContent } from "../../../components/LandingPage/PlatformPage"

export const LandingPlatformPage: FC = () => {
  return <PlatformPageContent />
}
